<template>
  <div>
    <div>
      <router-link to="/courses">
        <div class="d-flex align-center my-3">
          <v-icon>mdi-arrow-left-thin</v-icon>
          <span class="black--text"> Courses</span>
        </div>
      </router-link>
    </div>
    <div class="d-flex justify-space-between">
      <div class="heading-1 mb-9">[Name_course]</div>
      <!-- <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="pa-0 ma-0"
            depressed
            color="transparent"
          >
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <v-icon class="mr-3">mdi-open-in-new</v-icon>
              <span>Open Course</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <v-icon class="mr-3">mdi-pencil</v-icon>
              <span>Edit Course</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="AddSeminarDialog = true">
            <v-list-item-title>
              <v-icon class="mr-3">mdi-plus-circle-outline</v-icon>
              <span>Add new Seminar</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <v-icon class="mr-3">mdi-delete</v-icon>
              <span>Delete Course</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </div>
    <div class="my-14">
      <v-row>
        <v-row>
          <v-col cols="2"> <span class="span1"> Permission</span></v-col>
          <v-col cols="10"
            ><v-chip class="mr-1">Starter</v-chip
            ><v-chip class="mr-1">Practicing</v-chip
            ><v-chip class="mr-1">Instructor</v-chip></v-col
          >
        </v-row>

        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="4"> <span class="span1"> Display Order</span></v-col>
            <v-col cols="8"> <b> #</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> CEUs</span></v-col>
            <v-col cols="8"> <b> 16</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Visibility</span></v-col>
            <v-col cols="8"> <b> Publish</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Level</span></v-col>
            <v-col cols="8"> <b> Beginner</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Price</span></v-col>
            <v-col cols="8"> <b> USD 350.00</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Total Handouts</span></v-col>
            <v-col cols="8"> <b>#</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1">Royalty Payouts</span></v-col>
            <v-col cols="8">
              <span class="primary--text" style="cursor: pointer"
                >See Instructors</span
              ></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1">Livestream</span></v-col>
            <v-col cols="8"> <b> YES/NO</b></v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="4">
              <span class="span1"> Free with account creation</span></v-col
            >
            <v-col cols="8"> <b> YES/NO</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1">Expires 1 year from purchase</span></v-col
            >
            <v-col cols="8"> <b> YES/NO</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4"> <span class="span1"> Total Parts</span></v-col>
            <v-col cols="8"> <b>#</b></v-col>
          </v-row>

          <v-row>
            <v-col cols="4"> <span class="span1"> Category</span></v-col>
            <v-col cols="8"> <b> BodyTalk Courses</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1"> Course Translator</span></v-col
            >
            <v-col cols="8"> <b> Robin</b></v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span class="span1"> Course Instructors</span></v-col
            >
            <v-col cols="8">
              <span  
                ><b>Sherry Gilbert</b></span
              ></v-col
            >
          </v-row>

          <v-row>
            <v-col cols="4"> <span class="span1"> Language</span></v-col>
            <v-col cols="8"> <b> English</b></v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <!------------------image section--------------------------------->
    <div>
      <div class="span1 mb-4">Images 4/5</div>
      <div class="d-flex">
        <v-card flat>
          <v-img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUDH83f7IQeBd533wGmks0QtMlPkzOeSeXtw&usqp=CAU"
            class="mr-4"
            max-width="170"
          ></v-img>
        </v-card>
        <v-card flat>
          <v-img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUDH83f7IQeBd533wGmks0QtMlPkzOeSeXtw&usqp=CAU"
            class="mr-4"
            max-width="170"
          ></v-img>
        </v-card>
        <v-card flat>
          <v-img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUDH83f7IQeBd533wGmks0QtMlPkzOeSeXtw&usqp=CAU"
            class="mr-4"
            max-width="170"
          ></v-img> </v-card
        ><v-card flat>
          <v-img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUDH83f7IQeBd533wGmks0QtMlPkzOeSeXtw&usqp=CAU"
            class="mr-4"
            max-width="170"
          ></v-img>
        </v-card>
      </div>
    </div>
    <!------------------related courses section--------------------------------->
    <div class="mt-6 mb-14">
      <div class="span1 mb-4">Related courses 3/4</div>
      <v-row class="pa-2">
        <v-col
          cols="12"
          md="2"
          v-for="(item, index) in relatedContentArray"
          :key="index"
        >
          <v-card outlined style="border: 1px solid rgba(8, 8, 22, 0.15)" flat>
            <v-img height="150" :src="item.img"></v-img>
            <div class="pa-4">
              <span class="content_span"
                >Lorem ipsum dolor sit amet consectetur adropising</span
              >
              <div>
                <span class="content_date">September 23, 2021</span>
              </div>
              <div class="mt-3">
                <v-chip color="#E2F2E6" class="px-6">
                  <span class="content_chip"> Published </span></v-chip
                >
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!-- <v-divider class="divider"></v-divider> -->
    <!------------------------Seminars section---------------------------------------------->
    <!-- <div>
      <SaminarCourseComponent></SaminarCourseComponent>
    </div> -->
    <!------------------------Add Seminar section-------------------------------------------->
    <v-dialog v-model="AddSeminarDialog" max-width="520">
      <v-card class="py-2">
        <div class="d-flex justify-space-between px-10">
          <div class="heading1 my-5">Create new Seminar</div>
          <v-icon @click="AddSeminarDialog = close">mdi-close</v-icon>
        </div>
        <AddSeminarComponent
          :AddSeminarDialog="AddSeminarDialog"
          @close="CloseSeminar"
        ></AddSeminarComponent>
      </v-card>
    </v-dialog>
    <!-----------------------Seminar succes model-----Alert popup---------------------------->
    <v-dialog v-model="SuccessSeminarModel" max-width="500">
      <v-card class="pa-5">
        <div class="d-flex justify-end">
          <v-icon @click="SuccessSeminarModel = false">mdi-close</v-icon>
        </div>
        <div class="d-flex justify-center">
          <v-card-title class="text-h5">
            Seminar saved correctly!
          </v-card-title>
        </div>
        <div class="d-flex justify-center my-10">
          <router-link to="/courses">
            <v-btn class="px-14 py-6" color="primary">Back to Courses </v-btn>
          </router-link>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//import SaminarCourseComponent from "./SaminarCourser.component.vue";
import AddSeminarComponent from "./AddSeminar.component.vue";
export default {
  name: "PreviewNewCourseComponent",
  components: {
    //SaminarCourseComponent,
    AddSeminarComponent,
  },
  data() {
    return {
      AddSeminarDialog: false,
      SuccessSeminarModel: false,
      relatedContentArray: [
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
        {
          img: "https://cdn.vuetifyjs.com/images/cards/cooking.png",
          title: "Lorem ipsum dolor sit amet consectetur adropising",
          desc: "September 23, 2021",
        },
      ],
    };
  },
  methods: {
    CloseSeminar() {
      this.AddSeminarDialog = false;
      this.SuccessSeminarModel = true;
    },
  },
};
</script>

<style scoped>
.span1 {
  font-size: 14px;
  color: rgba(34, 34, 34, 0.7);
}
.heading1 {
  font-size: 24px;
  font-weight: 500;
}
</style>
